import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"leaflet-map"}}),(!_vm.multiple)?_c(VTextField,_vm._b({attrs:{"filled":"","hint":"Lat,Lng (e.g. 44.77,-64.66)","append-icon":_vm.required ? 'mdi-asterisk' : null,"rules":[_vm.coordsRules.coords],"required":_vm.required},on:{"input":_vm.onInput},model:{value:(_vm.coordsString),callback:function ($$v) {_vm.coordsString=$$v},expression:"coordsString"}},'v-text-field',_vm.commonProps,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }